/**
 * Sorting utilities for live events.
 * Pure TypeScript - no React imports.
 */

import moment from "moment";
import type {LiveEventListItem} from "../domain/types";

interface LiveEventListItemWithTimeDiff extends LiveEventListItem {
  timeDiff: number;
}

/**
 * Calculates time difference for a live event list item.
 * Uses eventDate (date-only string) for comparison.
 */
function calculateTimeDiff(event: LiveEventListItem): LiveEventListItemWithTimeDiff {
  const eventDate = event.eventDate;

  if (!eventDate) {
    return {...event, timeDiff: Number.MAX_SAFE_INTEGER};
  }

  const classStartTime = moment(eventDate, "YYYY-MM-DD", true);
  const dateToday = moment().startOf("day");
  const timeDiff = classStartTime.diff(dateToday, "days");

  return {...event, timeDiff};
}

/**
 * Sorts live event list items by date (soonest first).
 * Works with LiveEventListItem which has eventDate (date-only).
 */
export function sortLiveEventsByTime(
  events?: LiveEventListItem[]
): LiveEventListItemWithTimeDiff[] {
  if (!events || events.length === 0) {
    return [];
  }

  const eventsWithTimeDiff = events.map(calculateTimeDiff);
  return eventsWithTimeDiff.sort((a, b) => a.timeDiff - b.timeDiff);
}
